import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    body: translate({
      id: 'settings.rmAccount.view.resetApiKeyModal.header.body',
    }),
  }))

  return api
}
